import { RESET, SET_USERS, USER_UPDATE_ALERT } from "../actions/actionTypes";
import { DEFAULT_USERS_SORT } from "../actions/users";
import dataTableBehavior from "./dataTableBehavior";
import { extendUserWithRole } from "../services/roles";

const dataTable = dataTableBehavior("users");

const EMPTY_FILTERS = { company_id: "", access: "" };

const initialState = {
  all: [],
  total: 0,
  page: 1,
  query: "",
  sort: DEFAULT_USERS_SORT,
  filters: EMPTY_FILTERS,
  table: dataTable(undefined, {}), // eslint-disable-line no-undefined
  updateAlert: "",
};

export default function users(state = initialState, action) {
  switch (action.type) {
    case SET_USERS:
      return {
        ...state,
        all: action.users.map((user) => extendUserWithRole(user)),
        total: action.total,
        page: action.page,
        query: action.query,
        sort: action.sort ?? state.sort,
        filters: action.filters ?? state.filters,
        updateAlert: "",
      };

    case RESET:
      return initialState;

    case USER_UPDATE_ALERT:
      return {
        ...state,
        updateAlert: action.updateAlert,
      };

    default:
      return {
        ...state,
        table: dataTable(state.table, action),
      };
  }
}
